import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import _imports_0 from '../../assets/imgs/112233.png';
const _hoisted_1 = {
  class: "pc-nav"
};
const _hoisted_2 = {
  class: "header-wapper"
};
const _hoisted_3 = {
  class: "nav-link"
};
const _hoisted_4 = ["href", "onClick"];
const _hoisted_5 = {
  class: "mobile-nav"
};
const _hoisted_6 = {
  class: "mobile-header"
};
const _hoisted_7 = {
  key: 0,
  class: "mobile-menu"
};
const _hoisted_8 = {
  class: "mobile-menu-content"
};
const _hoisted_9 = ["href", "onClick"];
import { ref, onMounted, onUnmounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { Icon as VanIcon } from 'vant';
export default {
  __name: 'NavBar',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();

    /* ===== 7 个导航项 ===== */
    const navItems = [{
      path: '/',
      text: '首页'
    }, {
      path: '/about-company',
      text: '公司介绍'
    }, {
      path: '/product',
      text: '产品介绍'
    }, {
      path: '/tech',
      text: '技术核心'
    }, {
      path: '/scene',
      text: '应用场景'
    }, {
      path: '/contact',
      text: '联系我们'
    }, {
      path: '/download',
      text: '下载中心'
    }];
    const showMobileMenu = ref(false);
    const isMobile = ref(false);

    /* ===== 检查设备类型 ===== */
    const checkIsMobile = () => {
      isMobile.value = window.innerWidth <= 768;
    };

    /* ===== 导航点击处理 ===== */
    const handleNavClick = (path, event) => {
      event.preventDefault();
      router.push(path);
    };
    const handleMobileNavClick = (path, event) => {
      event.preventDefault();
      router.push(path);
      showMobileMenu.value = false;
    };

    /* ===== 路由变化时关闭移动端菜单 ===== */
    watch(() => route.path, () => {
      if (showMobileMenu.value) {
        showMobileMenu.value = false;
      }
    });

    /* ===== 响应式处理 ===== */
    onMounted(() => {
      checkIsMobile();
      window.addEventListener('resize', checkIsMobile);
    });
    onUnmounted(() => {
      window.removeEventListener('resize', checkIsMobile);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("nav", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "nav-logo"
      }, [_createElementVNode("img", {
        src: _imports_0,
        height: "36"
      })], -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, item => {
        return _createElementVNode("a", {
          key: item.path,
          href: item.path,
          class: _normalizeClass(["nav-item", {
            active: _ctx.$route.path === item.path
          }]),
          onClick: $event => handleNavClick(item.path, $event)
        }, _toDisplayString(item.text), 11, _hoisted_4);
      }), 64))])])]), _createElementVNode("nav", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        class: "hamburger",
        onClick: _cache[0] || (_cache[0] = $event => showMobileMenu.value = !showMobileMenu.value)
      }, _cache[3] || (_cache[3] = [_createElementVNode("span", {
        class: "hamburger-line"
      }, null, -1), _createElementVNode("span", {
        class: "hamburger-line"
      }, null, -1), _createElementVNode("span", {
        class: "hamburger-line"
      }, null, -1)])), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "mobile-logo"
      }, [_createElementVNode("img", {
        src: _imports_0,
        height: "32"
      })], -1)), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "mobile-right"
      }, null, -1))]), _createVNode(_Transition, {
        name: "slide-down"
      }, {
        default: _withCtx(() => [showMobileMenu.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, item => {
          return _createElementVNode("a", {
            key: item.path,
            href: item.path,
            class: _normalizeClass(["mobile-nav-item", {
              active: _ctx.$route.path === item.path
            }]),
            onClick: $event => handleMobileNavClick(item.path, $event)
          }, [_createTextVNode(_toDisplayString(item.text) + " ", 1), _ctx.$route.path === item.path ? (_openBlock(), _createBlock(_unref(VanIcon), {
            key: 0,
            name: "success",
            size: "16",
            color: "#00a0e9"
          })) : _createCommentVNode("", true)], 10, _hoisted_9);
        }), 64))])])) : _createCommentVNode("", true)]),
        _: 1
      }), showMobileMenu.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "mobile-menu-overlay",
        onClick: _cache[1] || (_cache[1] = $event => showMobileMenu.value = false)
      })) : _createCommentVNode("", true)])], 64);
    };
  }
};